import { Stack } from '@mui/material'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { TypographySecondaryBold16 } from 'ui/typography/TypographySecondaryBold16'

type NoDataPlaceholderProps = {
	height?: string | number
}

export const NoDataPlaceholder = ({
	height = '100%',
}: NoDataPlaceholderProps) => {
	return (
		<Stack
			direction='column'
			justifyContent='center'
			alignItems='center'
			gap='8px'
			flex={1}
			sx={{ height, width: '100%', textAlign: 'center' }}
		>
			<TypographySecondaryBold16>Нет данных</TypographySecondaryBold16>
			<TypographySecondary14>
				Нет данных, соответствующих выбранным условиям.
			</TypographySecondary14>
		</Stack>
	)
}
